import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/door-access/starter-kits/g2-starter-kit-pro.png";
import type { Product } from "../../types";
import { doorAccessStarterKits } from "../product-list-groups/doorAccessStarterKits";
import { touchPassSupport } from "../properties";
import { includedAccessories } from "../properties/includedAccessories";
import { includedHub } from "../properties/includedHub";
import { includedReaders } from "../properties/includedReaders";

export const g2StarterKitPro: Product = {
  id: "g2StarterKitPro",
  productTitle: "G2 Starter Kit Pro",
  productListGroup: doorAccessStarterKits,
  techspecsPath: [SiteId.TechSpecs, "/unifi/door-access/ua-g2-sk-pro"],
  storePathParts: { category: "all-door-access", productSlug: "ua-g2-sk-pro" },
  description: "g2StarterKitPro.description",
  descriptionMaxWidth: 300,
  image: { src: image, width: 200, height: 160 },
  propertyValues: [
    {
      propertyId: includedHub.id,
      value: {
        type: "translation",
        value: "g2StarterKitPro.includedHub",
      },
    },
    {
      propertyId: includedReaders.id,
      value: {
        type: "translation",
        value: "g2StarterKitPro.includedReaders",
      },
    },
    {
      propertyId: includedAccessories.id,
      value: {
        type: "translation",
        value: "g2StarterKitPro.includedAccessories",
      },
    },
    {
      propertyId: touchPassSupport.id,
      value: {
        type: "boolean",
        value: false,
      },
    },
  ],
};
